import { render, staticRenderFns } from "./person.vue?vue&type=template&id=ef51d140&scoped=true&"
import script from "./person.vue?vue&type=script&lang=tsx&"
export * from "./person.vue?vue&type=script&lang=tsx&"
import style0 from "./person.vue?vue&type=style&index=0&id=ef51d140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef51d140",
  null
  
)

export default component.exports